import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";


export default function Topbar({ onToggleTheme, dark, onToggleSidebar }) {
    const [openMenu, setOpenMenu] = useState(false);
    const [closing, setClosing] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [timeLeft, setTimeLeft] = useState(null);
    const [progress, setProgress] = useState(100);
    const [color, setColor] = useState("green");
    const [showExpireSoonToast, setShowExpireSoonToast] = useState(false);
    const [showExpiredToast, setShowExpiredToast] = useState(false);
    const [expireSoonShown, setExpireSoonShown] = useState( localStorage.getItem("expireSoonShown") === "true" );

    const navigate = useNavigate();
    const [notifOpen, setNotifOpen] = useState(false);
    const [notifClosing, setNotifClosing] = useState(false);
    const [shake, setShake] = useState(false);
    const TOKEN_MAX_DURATION = 24 * 60 * 60 * 1000; // 24h en ms

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded);
    }, [cookies.token]);

    const logout = () => {
        try {
            fetch("https://api.industriegaming.fr/api/auth/logout", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`
                }
            });
        } catch (err) {
            console.error("Erreur logout:", err);
        }

        removeCookie("token", { path: "/" }); // supprime le cookie JWT
        navigate("/"); // redirige vers la page de connexion
    };

    const stringToColor = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        const color = `hsl(${hash % 360}, 70%, 40%)`;
        return color;
    };


    const firstLetter = user?.name?.charAt(0).toUpperCase() || "U";



    // --- Tes serveurs ---
    const [servers, setServers] = useState([
        { name: "Bot Discord", url: "https://api.industriegaming.fr/api/ping/botdiscord", status: "offline", ping: null },
        { name: "Log Torrent", url: "https://api.industriegaming.fr/api/ping/logtorrent", status: "offline", ping: null },
        { name: "DB", url: "https://api.industriegaming.fr/api/ping/db", status: "offline", ping: null },
        { name: "PZ Admin", url: "https://api.industriegaming.fr/api/ping/dashboard", status: "offline", ping: null }
    ]);

    useEffect(() => {
        async function loadNotifications() {
            const res = await fetch("https://api.industriegaming.fr/api/auth/notification", {
                headers: {
                    "Authorization": `Bearer ${cookies.token}`
                }
            });
            const data = await res.json();
            setNotifications(data);
        }

        loadNotifications();
    }, []);

    function handleNotifClick(id) {
        fetch(`https://api.industriegaming.fr/api/auth/notification/${id}/read`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${cookies.token}`
            }
        });

        // Mise à jour immédiate du state pour l’UI
        setNotifications(prev =>
            prev.map(n => n.id === id ? { ...n, readed: true } : n)
        );
    }




    // --- Notifications ---
    // const notifications = [
    //     { id: 1, text: "Serveur API redémarré", type: "info" },
    //     { id: 2, text: "Erreur critique sur DB", type: "error" },
    //     { id: 3, text: "Maintenance programmée à 22h", type: "warning" },
    //     { id: 4, text: "Nouvel utilisateur inscrit", type: "info" },
    //     { id: 5, text: "6 Nouveau torrents", type: "new" },
    // ];


    const today = new Date();

    const formattedDate = today.toLocaleDateString("fr-FR", {
        weekday: "long",
        day: "numeric",
        month: "long"
    });

    const formattedTime = today.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });

    const pingServer = async (server) => {
        try {
            const controller = new AbortController();

            if (server.url === "none") {
                return{}
            }

            // Timeout de 3 secondes
            const timeout = setTimeout(() => controller.abort(), 3000);

            const res = await fetch(server.url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${cookies.token}`,
                    'Content-Type': 'application/json'
                },
                signal: controller.signal
            });

            clearTimeout(timeout);

            if (!res.ok) throw new Error("Bad response");

            const data = await res.json();

            return {
                status: "online",
                ping: data.responseTime ?? null
            };
        } catch (err) {
            return "offline";
        }
    };

    // Block pour le ping des serveurs, actuellement en maintenace.

    useEffect(() => {
        const checkServers = async () => {
            const updated = await Promise.all(
                servers.map(async (srv) => {
                    const result = await pingServer(srv);
                    return { ...srv, ...result };
                })
            );

            setServers(updated);
        };

        checkServers();
        const interval = setInterval(checkServers, 5000);

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        if (!cookies.token) return;

        const decoded = jwtDecode(cookies.token);
        const expiration = decoded.exp * 1000;
        const totalDuration = TOKEN_MAX_DURATION;

        const updateTimer = () => {
            const now = Date.now();
            const diff = expiration - now;

            if (diff <= 0) {
                setTimeLeft("Expiré");
                // Toast session expirée
                setShowExpiredToast(true);
                setTimeout(() => {
                    removeCookie("token", { path: "/" });
                    window.location.href = "/";
                    }, 1500);
                return;
            }

            // Calcul heures / minutes / secondes
            const hours = Math.floor(diff / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);

            if (hours > 0) {
                setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
            } else {
                setTimeLeft(`${minutes}m ${seconds}s`);
            }

            // Barre de progression
            const percent = (diff / totalDuration) * 100;
            setProgress(percent);

            if (diff <= 10 * 60 * 1000 && !expireSoonShown) {
                setShowExpireSoonToast(true);
                setExpireSoonShown(true);
                localStorage.setItem("expireSoonShown", "true");

                setTimeout(() => setShowExpireSoonToast(false), 4000);
            }

            // Couleurs selon le temps restant
            if (diff <= 10 * 60 * 1000) {
                setColor("red");
            } else if (diff <= 60 * 60 * 1000) {
                setColor("orange");
            } else {
                setColor("green");
            }
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [cookies.token]);


    const toggleNotif = () => {
        if (notifOpen) {
            setNotifClosing(true);
            setTimeout(() => {
                setNotifOpen(false);
                setNotifClosing(false);
            }, 150);
        } else {
            setNotifOpen(true);
        }
    };

    const closeNotif = () => {
        if (!notifOpen) return;
        setNotifClosing(true);
        setTimeout(() => {
            setNotifOpen(false);
            setNotifClosing(false);
        }, 150);
    };


    const triggerShake = () => {
        setShake(true);
        setTimeout(() => setShake(false), 600);
    };

    // --- Menu utilisateur ---
    const toggleMenu = () => {
        if (openMenu) {
            setClosing(true);
            setTimeout(() => {
                setOpenMenu(false);
                setClosing(false);
            }, 150);
        } else {
            setOpenMenu(true);
        }
    };

    const closeMenu = () => {
        if (!openMenu) return;
        setClosing(true);
        setTimeout(() => {
            setOpenMenu(false);
            setClosing(false);
        }, 150);
    };

    const unreadCount = notifications.filter(n => !n.readed).length;


    return (
        <header className="topbar">
            <div className="topbar-left">
                <button className="menu-btn" onClick={onToggleSidebar}>☰</button>
                <div className="topbar-title">Dashboard</div>
                <span
                    className="badge">{formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)} - {formattedTime}</span>

                {/* --- Tes statuts serveurs --- */}
                <div className="server-status-group">
                    {servers.map((srv, i) => (
                        <div
                            key={i}
                            className="server-status"
                            data-tooltip={
                                srv.status === "online"
                                    ? `${srv.name} : en ligne (${srv.ping} ms)`
                                    : `${srv.name} : hors ligne`
                            }
                        >
              <span
                  className={`status-dot ${srv.status === "online" ? "online" : "offline"}`}
              ></span>
                            <span className="server-name">{srv.name}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="topbar-right">

                <div className="session-container">
                    <div className={`session-timer ${color}`}>
                        Session : {timeLeft}
                    </div>

                    <div className="session-progress">
                        <div
                            className="session-progress-bar"
                            style={{width: `${progress}%`, backgroundColor: color}}
                        ></div>
                    </div>
                </div>

                <input className="search" placeholder="Rechercher…"/>

                {/* --- Cloche notifications --- */}
                <div className="notif-wrapper">
                    <div
                        className={`notif-bell ${shake ? "shake" : ""}`}
                        onClick={toggleNotif}
                    >
                        🔔
                        {unreadCount > 0 && (
                            <span className="notif-badge">{unreadCount}</span>
                        )}
                    </div>

                    {notifOpen && (
                        <div
                            className={`notif-menu ${notifClosing ? "closing" : ""}`}
                            onMouseLeave={closeNotif}
                        >
                            {notifications.map((n) => (
                                <div key={n.id} className={`notif-item ${n.type} ${n.readed ? "read" : ""}`} onClick={() => handleNotifClick(n.id)}>
                                    {/*<span className="notif-icon">*/}
                                    {/*  {n.type === "info" && "ℹ️ "}*/}
                                    {/*    {n.type === "warning" && "⚠️ "}*/}
                                    {/*    {n.type === "error" && "⛔ "}*/}
                                    {/*</span>*/}
                                    <span className="notif-badge-type">
                                        {n.type === "info" && "INFO"}
                                        {n.type === "maj" && (
                                            <>
                                                <i className="fa-solid fa-sync" aria-hidden="true" style={{ marginRight: 6 }}></i>
                                                MAJ
                                            </>
                                        )}
                                        {n.type === "warning" && "WARNING"}
                                        {n.type === "error" && "ERROR"}
                                        {n.type === "new" && "NEW"}
                                        {n.type === "user" && "USER"}
                                    </span>

                                    <span className="notif-text">{n.text}</span>
                                </div>
                            ))}

                        </div>
                    )}
                </div>


                {/* --- Bouton thème --- */}
                <button className="theme-toggle" onClick={onToggleTheme}>
                    {dark ? "☀️" : "🌙"}
                </button>

                {/* --- Menu utilisateur --- */}
                {user?.role === "Admin" && (
                    <>
                        <span className="admin-badge">Admin</span>
                    </>
                )}
                {user?.role === "Moderateur" && (
                    <span className="moderator-badge">Modérateur</span>
                )}

                <div className="avatar-wrapper">
                    <div className="avatar" style={{ backgroundColor: user ? stringToColor(user.name) : "#888" }} onClick={toggleMenu}>{firstLetter}</div>

                    {openMenu && (
                        <div
                            className={`user-menu ${closing ? "closing" : ""}`}
                            onMouseLeave={closeMenu}
                        >
                            <button onClick={() => navigate(`/profile/${user.userId}`)}>Mon profil</button>
                            <button onClick={() => navigate("/settings")}>Paramètres</button>
                            {user?.role === "Admin" && (
                                <button onClick={() => navigate("/chat-admin")}>Chat admin</button>
                            )}
                            <button onClick={logout}>Déconnexion</button>
                        </div>
                    )}
                </div>
            </div>
            {showExpireSoonToast && (
                <div className="toast-warning"> Votre session expire bientôt </div>
            )}
            {showExpiredToast && (
                <div className="toast-error"> Session expirée </div>
            )}
        </header>
    );
}
